"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftClaimStatusCodeInternalClaimStatusMapping = exports.DraftClaimStatusCodeExternalClaimStatusMapping = void 0;
var constants_1 = require("../constants");
exports.DraftClaimStatusCodeExternalClaimStatusMapping = (_a = {},
    _a[constants_1.DraftClaimStatus.ProcessInMics] = constants_1.ExternalClaimStatus.New,
    _a);
exports.DraftClaimStatusCodeInternalClaimStatusMapping = (_b = {},
    _b[constants_1.DraftClaimStatus.ProcessInMics] = constants_1.InternalClaimStatus.New,
    _b);
